(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('WikiEditController', WikiEditController);

    WikiEditController.$inject = ['$scope', '$state', '$stateParams', 'entity', 'Wiki'];

    function WikiEditController($scope, $state, $stateParams, entity, Wiki) {
        var vm = this;
        vm.wiki = entity;
        vm.spaceId = parseInt($stateParams.spaceId, 10);
        vm.wikis = [];
        vm.cancel = cancel;
        vm.goBack = goBack;
        vm.save = save;

        if (!vm.wiki.space) {
            vm.wiki.space = {id: vm.spaceId};
        }

        Wiki.query({spaceId: vm.spaceId}, function (data) {
            vm.wikis = data;
        });

        if (vm.wiki.superior && vm.wiki.superior.id) {
            Wiki.get({id: vm.wiki.superior.id}, function (data) {
                vm.wiki.superior = data;
            });
        }

        function goBack() {
            if (vm.wiki.id) {
                $state.go('detail-wiki', {spaceId: vm.spaceId, id: vm.wiki.id});
            } else {
                $state.go('wiki-space', {spaceId: vm.spaceId});
            }
        }

        function cancel() {
            goBack();
        }

        function save() {
            vm.isSaving = true;
            if (vm.wiki.id !== null) {
                Wiki.update(vm.wiki, onSaveSuccess, onSaveError);
            } else {
                Wiki.save(vm.wiki, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:wikiUpdate', result);
            $state.go('detail-wiki', {spaceId: vm.spaceId, id: result.id});
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
